import { Tabs } from "antd"

const HardKeysTab = (props) => {

    return <Tabs
        defaultActiveKey="1"
        type="card"
        size={5}
        items={new Array(1).fill(null).map((_, i) => {
            const id = String(i + 1);
            return {
                label: `Page ${id}`,
                key: id,
                children: <></>
            };
        })}
    />
}

export default HardKeysTab